var render = function render(){var _vm=this,_c=_vm._self._c;return _c('report-section',{staticClass:"blood-oxygen-distribution-section",attrs:{"title":"血氧饱和度分布占比"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',[_c('div',{staticClass:"bar-chart",attrs:{"id":_vm.title}})])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }